/* Shared helpers for FCM web push */

export function stripFirebaseClientConfig(config) {
  if (!config) return { appConfig: null, vapidKey: null };
  const { vapidKey, ...appConfig } = config;
  return { appConfig, vapidKey: vapidKey || null };
}

export async function waitForServiceWorker(reg) {
  if (reg.active) return reg.active;
  return new Promise((resolve) => {
    const sw = reg.installing || reg.waiting;
    if (!sw) {
      resolve(reg.active);
      return;
    }
    sw.addEventListener('statechange', () => {
      if (sw.state === 'activated') resolve(reg.active || sw);
    });
  });
}

export async function initSwFirebase(config) {
  const reg = await navigator.serviceWorker.ready;
  const active = await waitForServiceWorker(reg);
  const { appConfig } = stripFirebaseClientConfig(config);
  if (active) {
    active.postMessage({ type: 'INIT_FIREBASE', config: appConfig });
  }
  return reg;
}

export function isIosDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function isStandalonePwa() {
  return window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
}

export function pushSupported() {
  return typeof window !== 'undefined'
    && 'serviceWorker' in navigator
    && 'Notification' in window;
}
